(function () {
  window.MF_QUOTE_PORTRAITS = {
  "Abraham Lincoln": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Abraham_Lincoln_1863_Portrait_%283x4_cropped%29.jpg/330px-Abraham_Lincoln_1863_Portrait_%283x4_cropped%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Abraham_Lincoln_1863_Portrait_(3x4_cropped).jpg",
    "credit": "Alexander Gardner",
    "license": "Public domain"
  },
  "Albert Einstein": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Albert_Einstein_Head_cleaned.jpg/330px-Albert_Einstein_Head_cleaned.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Albert_Einstein_Head_cleaned.jpg",
    "credit": "Orren Jack Turner",
    "license": "Public domain"
  },
  "Alexander Graham Bell": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Alexander_Graham_Bell_1895_NPG_77_363.jpg/330px-Alexander_Graham_Bell_1895_NPG_77_363.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Alexander_Graham_Bell_1895_NPG_77_363.jpg",
    "credit": "Unknown author Unknown author",
    "license": "CC0"
  },
  "Alfred Mercier": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Alfred_Mercier.jpg/330px-Alfred_Mercier.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Alfred_Mercier.jpg",
    "credit": "Unknown photographer",
    "license": "Public domain"
  },
  "Alice Walker": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Alice_Walker.jpg/330px-Alice_Walker.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Alice_Walker.jpg",
    "credit": "Virginia DeBolt",
    "license": "CC BY-SA 2.0"
  },
  "Amelia Earhart": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/Amelia_Earhart_standing_under_nose_of_her_Lockheed_Model_10-E_Electra%2C_small_%28cropped%29.jpg/330px-Amelia_Earhart_standing_under_nose_of_her_Lockheed_Model_10-E_Electra%2C_small_%28cropped%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Amelia_Earhart_standing_under_nose_of_her_Lockheed_Model_10-E_Electra,_small_(cropped).jpg",
    "credit": "Underwood & Underwood (active 1880 – c. 1950) [1]",
    "license": "Public domain"
  },
  "Antoine de Saint-Exupery": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/4/4a/11exupery-inline1-500_%28cropped%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:11exupery-inline1-500_(cropped).jpg",
    "credit": "Distributed by Agence France-Presse",
    "license": "Public domain"
  },
  "Aristotle": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Aristotle_Altemps_Inv8575.jpg/330px-Aristotle_Altemps_Inv8575.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Aristotle_Altemps_Inv8575.jpg",
    "credit": "After Lysippos",
    "license": "Public domain"
  },
  "Audre Lorde": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Audre_Lorde.jpg/330px-Audre_Lorde.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Audre_Lorde.jpg",
    "credit": "K. Kendall",
    "license": "CC BY 2.0"
  },
  "Ayn Rand": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Ayn_Rand_%281943_Talbot_portrait%29.jpg/330px-Ayn_Rand_%281943_Talbot_portrait%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Ayn_Rand_(1943_Talbot_portrait).jpg",
    "credit": "Photo portrait credited to \"Talbot\" (though not on original dust jacket). Published by the Bobbs-Merrill Company .",
    "license": "Public domain"
  },
  "B. B. King": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Bbking.jpg/330px-Bbking.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Bbking.jpg",
    "credit": "Marco Tambara / Lightversus",
    "license": "CC BY-SA 3.0"
  },
  "Babe Ruth": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Babe_Ruth2.jpg/330px-Babe_Ruth2.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Babe_Ruth2.jpg",
    "credit": "Irwin, La Broad, & Pudlin.",
    "license": "Public domain"
  },
  "Benjamin Franklin": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Joseph_Siffrein_Duplessis_-_Benjamin_Franklin_-_Google_Art_Project.jpg/330px-Joseph_Siffrein_Duplessis_-_Benjamin_Franklin_-_Google_Art_Project.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Joseph_Siffrein_Duplessis_-_Benjamin_Franklin_-_Google_Art_Project.jpg",
    "credit": "Joseph-Siffred Duplessis",
    "license": "Public domain"
  },
  "Beverly Sills": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/0/04/Beverly_Sills_by_Van_Vechten.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Beverly_Sills_by_Van_Vechten.jpg",
    "credit": "Carl Van Vechten",
    "license": "Public domain"
  },
  "Billie Jean King": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Billie_Jean_King_at_the_2026_Sundance_Film_Festival_02_%28crop_2%29.jpg/330px-Billie_Jean_King_at_the_2026_Sundance_Film_Festival_02_%28crop_2%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Billie_Jean_King_at_the_2026_Sundance_Film_Festival_02_(crop_2).jpg",
    "credit": "Claire Fridkin",
    "license": "CC BY-SA 4.0"
  },
  "Confucius": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/54/Confucius_Tang_Dynasty.jpg/330px-Confucius_Tang_Dynasty.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Confucius_Tang_Dynasty.jpg",
    "credit": "Wu Daozi , 685-758, Tang Dynasty.",
    "license": "Public domain"
  },
  "Eleanor Roosevelt": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Eleanor_Roosevelt_at_the_United_Nations%2C_circa_1946-1947_%283x4_cropped%29.jpg/330px-Eleanor_Roosevelt_at_the_United_Nations%2C_circa_1946-1947_%283x4_cropped%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Eleanor_Roosevelt_at_the_United_Nations,_circa_1946-1947_(3x4_cropped).jpg",
    "credit": "FDR Presidential Library & Museum",
    "license": "CC BY 2.0"
  },
  "Emily Dickinson": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Black-white_photograph_of_Emily_Dickinson2.png/330px-Black-white_photograph_of_Emily_Dickinson2.png",
    "source": "https://commons.wikimedia.org/wiki/File:Black-white_photograph_of_Emily_Dickinson2.png",
    "credit": "Unknown author Unknown author",
    "license": "Public domain"
  },
  "Epictetus": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Epicteti_Enchiridion_Latinis_versibus_adumbratum_%28Oxford_1715%29_frontispiece_%28cropped%29.jpg/330px-Epicteti_Enchiridion_Latinis_versibus_adumbratum_%28Oxford_1715%29_frontispiece_%28cropped%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Epicteti_Enchiridion_Latinis_versibus_adumbratum_(Oxford_1715)_frontispiece_(cropped).jpg",
    "credit": "William Sonmans / Michael Burghers",
    "license": "Public domain"
  },
  "Estee Lauder": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Estee_Lauder_NYWTS_%28cropped%29.jpg/330px-Estee_Lauder_NYWTS_%28cropped%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Estee_Lauder_NYWTS_(cropped).jpg",
    "credit": "New York World-Telegram and the Sun staff photographer: Sauro, Bill, photographer.",
    "license": "Public domain"
  },
  "Francis Bacon": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Somer_Francis_Bacon.jpg/330px-Somer_Francis_Bacon.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Somer_Francis_Bacon.jpg",
    "credit": "Paul van Somer I / Formerly attributed to Frans Pourbus the Younger",
    "license": "Public domain"
  },
  "Frank Sinatra": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Frank_Sinatra_%281957_studio_portrait_close-up%29.jpg/330px-Frank_Sinatra_%281957_studio_portrait_close-up%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Frank_Sinatra_(1957_studio_portrait_close-up).jpg",
    "credit": "Photograph by Capitol Records , per a credit found in the 1959 edition of the International Celebrity Register at page 696 . No known source credits an individual photographer.",
    "license": "Public domain"
  },
  "Franklin D. Roosevelt": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/FDR-1944-Campaign-Portrait_%283x4_retouched%2C_cropped%29.jpg/330px-FDR-1944-Campaign-Portrait_%283x4_retouched%2C_cropped%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:FDR-1944-Campaign-Portrait_(3x4_retouched,_cropped).jpg",
    "credit": "Leon Perskie",
    "license": "CC BY 2.0"
  },
  "Frederick Douglass": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Frederick_Douglass_%28circa_1879%29_%28cropped%29.jpg/330px-Frederick_Douglass_%28circa_1879%29_%28cropped%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Frederick_Douglass_(circa_1879)_(cropped).jpg",
    "credit": "George Kendall Warren",
    "license": "Public domain"
  },
  "George Washington": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Gilbert_Stuart_Williamstown_Portrait_of_George_Washington.jpg/330px-Gilbert_Stuart_Williamstown_Portrait_of_George_Washington.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Gilbert_Stuart_Williamstown_Portrait_of_George_Washington.jpg",
    "credit": "Gilbert Stuart",
    "license": "Public domain"
  },
  "Helen Hayes": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Helen_Hayes_1948.jpg/330px-Helen_Hayes_1948.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Helen_Hayes_1948.jpg",
    "credit": "Toronto Star",
    "license": "Public domain"
  },
  "Henry David Thoreau": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Benjamin_D._Maxham_-_Henry_David_Thoreau_-_Restored.jpg/330px-Benjamin_D._Maxham_-_Henry_David_Thoreau_-_Restored.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Benjamin_D._Maxham_-_Henry_David_Thoreau_-_Restored.jpg",
    "credit": "Benjamin D. Maxham active 1848 - 1858",
    "license": "Public domain"
  },
  "Henry Ford": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Henry_Ford_portrait_1915_original_%283x4_cropped%29.png/330px-Henry_Ford_portrait_1915_original_%283x4_cropped%29.png",
    "source": "https://commons.wikimedia.org/wiki/File:Henry_Ford_portrait_1915_original_(3x4_cropped).png",
    "credit": "Ford Motor Company. Photographic Department",
    "license": "Public domain"
  },
  "J. K. Rowling": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/J._K._Rowling_2010.jpg/330px-J._K._Rowling_2010.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:J._K._Rowling_2010.jpg",
    "credit": "Daniel Ogren",
    "license": "CC BY 2.0"
  },
  "J. R. R. Tolkien": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/J._R._R._Tolkien%2C_ca._1925.jpg/330px-J._R._R._Tolkien%2C_ca._1925.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:J._R._R._Tolkien,_ca._1925.jpg",
    "credit": "Unknown photo studio commissioned by Tolkien's students 1925/6 (private communication from Catherine McIlwaine, Tolkien Archivist, Bodleian Library)",
    "license": "Public domain"
  },
  "Lao Tzu": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Lao_Tzu_-_Project_Gutenberg_eText_15250.jpg/330px-Lao_Tzu_-_Project_Gutenberg_eText_15250.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Lao_Tzu_-_Project_Gutenberg_eText_15250.jpg",
    "credit": "Unknown author Unknown author",
    "license": "Public domain"
  },
  "Leonardo da Vinci": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Francesco_Melzi_-_Portrait_of_Leonardo.png/330px-Francesco_Melzi_-_Portrait_of_Leonardo.png",
    "source": "https://commons.wikimedia.org/wiki/File:Francesco_Melzi_-_Portrait_of_Leonardo.png",
    "credit": "Attributed to Francesco Melzi",
    "license": "Public domain"
  },
  "Mahatma Gandhi": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Mahatma-Gandhi%2C_studio%2C_1931.jpg/330px-Mahatma-Gandhi%2C_studio%2C_1931.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Mahatma-Gandhi,_studio,_1931.jpg",
    "credit": "Elliott & Fry",
    "license": "Public domain"
  },
  "Marcus Aurelius": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/MSR-ra-61-b-1-DM.jpg/330px-MSR-ra-61-b-1-DM.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:MSR-ra-61-b-1-DM.jpg",
    "credit": "Daniel Martin",
    "license": "CC BY-SA 4.0"
  },
  "Mark Twain": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Mark_Twain_by_AF_Bradley_%28cropped_2%29.jpg/330px-Mark_Twain_by_AF_Bradley_%28cropped_2%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Mark_Twain_by_AF_Bradley_(cropped_2).jpg",
    "credit": "A.F. Bradley, New York",
    "license": "Public domain"
  },
  "Maya Angelou": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Angelou_at_Clinton_inauguration_%28cropped_2%29.jpg/330px-Angelou_at_Clinton_inauguration_%28cropped_2%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Angelou_at_Clinton_inauguration_(cropped_2).jpg",
    "credit": "Clinton Library",
    "license": "Public domain"
  },
  "Michael Jordan": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Michael_Jordan_in_2014.jpg/330px-Michael_Jordan_in_2014.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Michael_Jordan_in_2014.jpg",
    "credit": "DOD photo by D. Myles Cullen",
    "license": "Public domain"
  },
  "Muhammad Ali": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Muhammad_Ali_NYWTS.jpg/330px-Muhammad_Ali_NYWTS.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Muhammad_Ali_NYWTS.jpg",
    "credit": "Ira Rosenberg",
    "license": "Public domain"
  },
  "Nelson Mandela": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Nelson_Mandela_1994.jpg/330px-Nelson_Mandela_1994.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Nelson_Mandela_1994.jpg",
    "credit": "Kingkongphoto & www.celebrity-photos.com from Laurel",
    "license": "CC BY-SA 2.0"
  },
  "Pablo Picasso": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Pablo_picasso_1.jpg/330px-Pablo_picasso_1.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Pablo_picasso_1.jpg",
    "credit": "Argentina . Revista Vea y Lea",
    "license": "Public domain"
  },
  "Plutarch": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Portrait_of_a_philosopher%2C_maybe_Plutarch%2C_2nd_century_BC%2C_AM_Delphi%2C_0135.jpg/330px-Portrait_of_a_philosopher%2C_maybe_Plutarch%2C_2nd_century_BC%2C_AM_Delphi%2C_0135.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Portrait_of_a_philosopher,_maybe_Plutarch,_2nd_century_BC,_AM_Delphi,_0135.jpg",
    "credit": "Zde",
    "license": "CC BY-SA 4.0"
  },
  "Ralph Waldo Emerson": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Ralph_Waldo_Emerson_by_Josiah_Johnson_Hawes_1857.jpg/330px-Ralph_Waldo_Emerson_by_Josiah_Johnson_Hawes_1857.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Ralph_Waldo_Emerson_by_Josiah_Johnson_Hawes_1857.jpg",
    "credit": "Josiah Johnson Hawes",
    "license": "Public domain"
  },
  "Robert Frost": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Robert_Frost_NYWTS_4.jpg/330px-Robert_Frost_NYWTS_4.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Robert_Frost_NYWTS_4.jpg",
    "credit": "Walter Albertin, World Telegram staff photographer",
    "license": "Public domain"
  },
  "Seneca": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Duble_herma_of_Socrates_and_Seneca_Antikensammlung_Berlin_07.jpg/330px-Duble_herma_of_Socrates_and_Seneca_Antikensammlung_Berlin_07.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Duble_herma_of_Socrates_and_Seneca_Antikensammlung_Berlin_07.jpg",
    "credit": "Calidius",
    "license": "CC BY-SA 3.0"
  },
  "Socrates": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Socrates_Louvre.jpg/330px-Socrates_Louvre.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Socrates_Louvre.jpg",
    "credit": "Copy of Lysippos (?)",
    "license": "Public domain"
  },
  "Steve Jobs": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Steve_Jobs_Headshot_2010_%28cropped_4%29.jpg/330px-Steve_Jobs_Headshot_2010_%28cropped_4%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Steve_Jobs_Headshot_2010_(cropped_4).jpg",
    "credit": "Matthew Yohe",
    "license": "CC BY-SA 3.0"
  },
  "Theodore Roosevelt": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Theodore_Roosevelt_by_the_Pach_Bros_%284x5_cropped%29_%282%29.jpg/330px-Theodore_Roosevelt_by_the_Pach_Bros_%284x5_cropped%29_%282%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Theodore_Roosevelt_by_the_Pach_Bros_(4x5_cropped)_(2).jpg",
    "credit": "Adam Cuerden",
    "license": "Public domain"
  },
  "Thomas Carlyle": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/Thomas_Carlyle._Photograph_by_Elliott_%26_Fry._Wellcome_V0027634_%28Cropped%29.jpg/330px-Thomas_Carlyle._Photograph_by_Elliott_%26_Fry._Wellcome_V0027634_%28Cropped%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Thomas_Carlyle._Photograph_by_Elliott_%26_Fry._Wellcome_V0027634_(Cropped).jpg",
    "credit": "https://wellcomeimages.org/indexplus/obf_images/f0/6c/b554ec34381c2fcb57e351a309bb.jpg Gallery: https://wellcomeimages.org/indexplus/image/V0027634.html Wellcome Collection gallery (2018-04-05): https://wellcomecollection.org/works/npw5y2mh CC-BY-4.0",
    "license": "CC BY 4.0"
  },
  "Thomas Edison": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Thomas_Edison2.jpg/330px-Thomas_Edison2.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Thomas_Edison2.jpg",
    "credit": "Louis Bachrach, Bachrach Studios , restored by Michel Vuijlsteke",
    "license": "Public domain"
  },
  "Tommy Lasorda": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Tommy_Lasorda_1981.jpg/330px-Tommy_Lasorda_1981.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Tommy_Lasorda_1981.jpg",
    "credit": "Series: Reagan White House Photographs, 1/20/1981 - 1/20/1989 Collection: White House Photographic Collection, 1/20/1981 - 1/20/1989",
    "license": "Public domain"
  },
  "Toni Morrison": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Toni_Morrison.jpg/330px-Toni_Morrison.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Toni_Morrison.jpg",
    "credit": "John Mathew Smith ( celebrity-photos.com )",
    "license": "CC BY-SA 2.0"
  },
  "Victor Hugo": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Victor_Hugo_by_%C3%89tienne_Carjat_1876_-_full.jpg/330px-Victor_Hugo_by_%C3%89tienne_Carjat_1876_-_full.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Victor_Hugo_by_%C3%89tienne_Carjat_1876_-_full.jpg",
    "credit": "Étienne Carjat",
    "license": "Public domain"
  },
  "Walt Disney": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Walt_Disney_1946_%28cropped2%29.JPG/330px-Walt_Disney_1946_%28cropped2%29.JPG",
    "source": "https://commons.wikimedia.org/wiki/File:Walt_Disney_1946_(cropped2).JPG",
    "credit": "Boy Scouts of America",
    "license": "Public domain"
  },
  "Wayne Gretzky": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Andrew_Scheer_with_Wayne_Gretzky_%2848055697168%29_%28cropped%29.jpg/330px-Andrew_Scheer_with_Wayne_Gretzky_%2848055697168%29_%28cropped%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Andrew_Scheer_with_Wayne_Gretzky_(48055697168)_(cropped).jpg",
    "credit": "Andre Forget - Andrew Scheer",
    "license": "CC0"
  },
  "William Butler Yeats": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/William_Butler_Yeats_by_George_Charles_Beresford.jpg/330px-William_Butler_Yeats_by_George_Charles_Beresford.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:William_Butler_Yeats_by_George_Charles_Beresford.jpg",
    "credit": "George Charles Beresford",
    "license": "Public domain"
  },
  "William James": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/William_James_b1842c.jpg/330px-William_James_b1842c.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:William_James_b1842c.jpg",
    "credit": "Notman Studios (photographer)",
    "license": "Public domain"
  },
  "Winston Churchill": {
    "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Sir_Winston_Churchill_-_19086236948_%28restored%29.jpg/330px-Sir_Winston_Churchill_-_19086236948_%28restored%29.jpg",
    "source": "https://commons.wikimedia.org/wiki/File:Sir_Winston_Churchill_-_19086236948_(restored).jpg",
    "credit": "Yousuf Karsh",
    "license": "Public domain"
  }
};
})();

